/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-array-index-key */
import {
    Col, Row, Overlay, Popover,
} from 'react-bootstrap';
import { Button, TextArea } from 'appkit-react';
import moment from 'moment';
import { useRef } from 'react';

const CommentsSection = ({
    getUser, comment, setComment, commentLoading, addComment,
    loading, getUserComments, edit, handleClick, show,
    target, onEditClick, onClickDelete, selectedIndex,
    selectedComment, setSelectedComment, onCancelClick, onClickSave,
}) => {
    const ref = useRef(null);
    return (
        <div className="true-comply-result__comment">
            <Row>
                <Col sm={1} md={1}>
                    <div className="true-comply-result__comment-initial">{getUser?.data?.getUser.initials}</div>
                </Col>
                <Col sm={10} md={10}>
                    <TextArea textBoxSize="lg" placeholder="Add a Comment" type="text" value={comment} onChange={e => setComment(e)} />
                </Col>
            </Row>
            <Row>
                <Col sm={11} md={11}>
                    <div className="float-right" style={{ marginTop: '0.5rem' }}>
                        <Button className="true-comply-result__comment-cancel-btn" onClick={() => setComment('')}>Cancel</Button>
                        <Button disabled={!comment} size="xl" isLoading={commentLoading} className="true-comply-result__comment-comment-btn" onClick={addComment}>Comment</Button>
                    </div>
                </Col>
            </Row>
            <div className="hr-line" />
            {
                loading ? <div className="a-loading a-primary a-m-10" /> : getUserComments && getUserComments.length > 0 && (
                    getUserComments.map(({
                        createdAt, commentText, commentId, userId, user,
                    }, index) => {
                        const { firstName, lastName, initials } = user;
                        return (
                            <Row key={index} className="marginTop30">
                                <Col sm={1} md={1}>
                                    <div className="true-comply-result__comment-initial">{initials}</div>
                                </Col>
                                <Col sm={10} md={10}>
                                    <span className="true-comply-result__comment-text">
                                        {`${firstName} ${lastName}`}
                                        {!edit && userId === (getUser.data && getUser.data.getUser.userId)
                                            && (
                                                <div ref={ref}>
                                                    <span
                                                        className="float-right true-comply-result__comment-text-action"
                                                        onClick={event => handleClick(index, commentText, commentId, event)}
                                                        aria-hidden="true"
                                                    >
                                                        ...
                                                    </span>
                                                    <Overlay
                                                        show={show}
                                                        target={target}
                                                        placement="bottom"
                                                        container={ref.current}
                                                        containerPadding={20}
                                                    >
                                                        <Popover id="popover-contained">
                                                            <Popover.Content>
                                                                <ul className="true-comply-result__comment-text-action__list">
                                                                    <li
                                                                        onClick={onEditClick}
                                                                        aria-hidden="true"
                                                                    >
                                                                        Edit
                                                                    </li>
                                                                    <li
                                                                        onClick={onClickDelete}
                                                                        aria-hidden="true"
                                                                    >
                                                                        Delete
                                                                    </li>
                                                                </ul>
                                                            </Popover.Content>
                                                        </Popover>
                                                    </Overlay>
                                                </div>
                                            )}
                                    </span>
                                    {
                                        (!edit || selectedIndex !== index)
                                            ? (
                                                <>
                                                    <p className="true-comply-result__comment-text">{commentText}</p>
                                                    <p
                                                        className="true-comply-result__comment-subtext"
                                                    >
                                                        {moment(createdAt).format('LLLL')}
                                                    </p>
                                                </>
                                            )
                                            : (
                                                <>
                                                    <input
                                                        className="true-comply-result__comment-input"
                                                        value={selectedComment}
                                                        onChange={event => setSelectedComment(event.target.value)}
                                                        type="text"
                                                    />
                                                    <p
                                                        className="float-right true-comply-result__comment-button-group"
                                                    >
                                                        <span onClick={onCancelClick} aria-hidden="true">Cancel</span>
                                                        <span
                                                            onClick={onClickSave}
                                                            aria-hidden="true"
                                                        >
                                                            Save
                                                        </span>
                                                    </p>
                                                </>
                                            )
                                    }
                                </Col>
                            </Row>
                        );
                    })
                )
            }
        </div>
    );
};

export default CommentsSection;
